@use '../../scss/utility';

@use './link-common';
@use './link-style-api';

:host {
  @include link-common.wb-link;
}

a {
  @include link-common.wb-link-inner;
}

:host([variant='inline']) a {
  @include link-common.wb-link-inline;
}

:host([variant='standalone']) a {
  @include link-common.wb-link-standalone;
  @include link-common.wb-link-standalone-type;
}

:host([variant='small']) a {
  @include link-common.wb-link-small-type;
}

:host([variant='tiny']) a {
  @include link-common.wb-link-tiny-type;
}

:host([variant='small']) a,
:host([variant='tiny']) a {
  @include link-common.wb-link-small-tiny;
}

:host([variant='standalone']) a,
:host([variant='small']) a,
:host([variant='tiny']) a {
  @include link-common.wb-link-standalone-small-tiny;
}

:host([is-rtl]) a {
  @include link-common.wb-link-rtl;
}

:host([variant='standalone']:hover) a,
:host([variant='standalone']:focus-within) a,
:host([variant='small']:hover) a,
:host([variant='small']:focus-within) a,
:host([variant='tiny']:hover) a,
:host([variant='tiny']:focus-within) a {
  @include link-common.wb-link-standalone-small-tiny-hover-focus-within;
}

:host([variant='standalone'][size='s']) a {
  @include link-common.wb-link-size-small;
}

:host([variant='standalone'][size='m']) a {
  @include link-common.wb-link-size-medium;
}

:host([variant='standalone'][size='l']) a {
  @include link-common.wb-link-size-large;
}

::slotted(.wb-icon) {
  @include link-common.wb-link-icon;
}
